import { dateSchema, FormInitializerReturnType, stringSchema } from 'src/Configuration/validation'
import type { ChangeInstallationOwnerFormData } from '../../components/modals/change-installation-owner-modal/types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { object, string } from 'yup'
import { endOfDay } from '@e3dc-react/shell/Libs/date'
import { OWNER_CHANGE_MIN_DATE } from '../../const'

const MIN_STRING_LENGTH = 3
const MAX_STRING_LENGTH = 1000

/**
 *  Initializes the form for changing the installation owner
 * @param today Todays Date
 * @returns initialValues and validationSchema for changing installations owner form
 */
export const useChangeInstallationOwnerFormInitializer = (
  today: Date
): FormInitializerReturnType<ChangeInstallationOwnerFormData, ChangeInstallationOwnerFormData> => {
  const { t } = useCustomTranslation()
  const stringSchemaWithTranslation = stringSchema(t)
  const dateSchemaWithTranslation = dateSchema(t)
  const initialValues: ChangeInstallationOwnerFormData = {
    reason: '',
    startAt: today,
    userId: '',
  }

  const validationSchema = object().shape({
    userId: string().required(),
    startAt: dateSchemaWithTranslation({ maxDate: endOfDay(new Date()), minDate: new Date(OWNER_CHANGE_MIN_DATE) }).required(),
    reason: stringSchemaWithTranslation({ maxLength: MAX_STRING_LENGTH, minLength: MIN_STRING_LENGTH }).required(),
  })
  return { initialValues, validationSchema }
}
